import { AppContext } from "@/components/AppContext";
import React from "react";

export default function useApp() {
    return React.useContext(AppContext);
}
